import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrimSpacesDirective } from 'app/modules/shared/directives/trim-spaces.directive';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { JsonPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ConfigService } from 'app/modules/shared/services/config.service';

@Component({
  selector: 'app-mi-input',
  templateUrl: './mi-input.component.html',
  styleUrls: ['./mi-input.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputTextModule, KeyFilterModule, TrimSpacesDirective, JsonPipe]
})
export class MiInputComponent implements OnInit {
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  @Input() pKeyFilter: string = null;
  formName: FormGroup;
  placeholder: any;
  private subscriptions: Subscription[] = [];
  isSponsor = this.configService.isSponsorUser();
  isSiteUser = this.configService.isSiteUser();

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,  private configService: ConfigService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    this.placeholder = this.placeholder === null ? '' : this.placeholder;

    const controlName = this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode;
    const control = this.formName.get(controlName);

    if (control) {
      if (this.field?.disabled) {
        control.disable();
      } else {
        control.enable();
      }
    }
    if (this.moduleName === 'user_detail' && (this.isSponsor || this.isSiteUser)) {
      this.formName.controls.first_name?.disable();
      this.formName.controls.last_name?.disable();
    }
  }
}
